import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const AuthContext = createContext(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("lashdollz_admin_token"));
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (active) setAdmin(data);
      } catch (e) {
        if (active) {
          setAdmin(null);
          setToken(null);
          localStorage.removeItem("lashdollz_admin_token");
        }
      } finally {
        if (active) setLoading(false);
      }
    };
    check();
    return () => {
      active = false;
    };
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("lashdollz_admin_token", data.token);
    setToken(data.token);
    setAdmin({ email: data.email, name: data.name });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("lashdollz_admin_token");
    setToken(null);
    setAdmin(null);
  };

  const authHeader = () => (token ? { Authorization: `Bearer ${token}` } : {});

  return (
    <AuthContext.Provider value={{ token, admin, loading, login, logout, authHeader }}>
      {children}
    </AuthContext.Provider>
  );
}
